/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useMemo, useRef, useEffect} from 'react';
import * as THREE from "three";
// import { useSelector } from 'react-redux';

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, railLoftModel, railModel } from '../../../../../utils/Functions';
import { CSG } from '../../../../../assets/libs/csg-lib'; 
import BaseRailModel from '../../BaseRail';
import PillarRailModel from '../../Legs';

const TWCT = ({ normalMap, envMap, trussModelPosInfoArr, overlapTrussArr, hiddenBaseRailIdArr }) => {

    let meshDelModel_CSG = {};
    const wallValueArr = ['front', 'back', 'left', 'right', 'backStorageFront', 'leftStorageFront', 'rightStorageFront'];

    wallValueArr.forEach((item) => {
        const meshDelModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(delModel(item, 'leg'), extrudeSettings(3)),
            new THREE.MeshStandardMaterial({ color: 'red' })
        )
        const meshDelModel_Temp = meshDelModel.clone();

        if (item === 'front' || item === 'back'|| item === 'backStorageFront') {
            meshDelModel_Temp.position.set(0, 0, -1.5)
        } else {
            meshDelModel_Temp.rotateY(-Math.PI / 2)
            meshDelModel_Temp.position.set(1.5, 0, 0)
        }
        meshDelModel_Temp.updateMatrix();
        meshDelModel_Temp.updateMatrixWorld();
        
        const mesh_CSG = CSG.fromMesh(meshDelModel_Temp);
        
        meshDelModel_CSG = { ...meshDelModel_CSG,  [item]: mesh_CSG };
    })

    return (
        <>
            <BaseRailModel normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} />
            <PillarRailModel trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} />
            <TrussModel trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} />
        </>
    )
}

export default TWCT

const TrussModel = ({ trussModelPosInfoArr, normalMap, envMap, overlapTrussArr, hiddenBaseRailIdArr }) => {   

    const obj_upperTrussNormal = new THREE.Object3D();
    const obj_upperTrussHighlight = new THREE.Object3D();
    const obj_sideSlopeRail = new THREE.Object3D();
    const obj_loftPieceRail = new THREE.Object3D();
    const obj_rungHRail = new THREE.Object3D();
    const obj_centerVRail = new THREE.Object3D();

    const ref_upperTrussNormal = useRef();
    const ref_sideSlopeRail = useRef();
    const ref_loftPieceRail = useRef();
    const ref_rungHRail = useRef();
    const ref_centerVRail = useRef();
    
    const connectRailWidth = 0.3;
    const connectRailHeight = 0.2;
    const offset = 0.035;   
    const sideEdgeSlopeRailLength = 2.5;
    const sideEdgeSlopeRailAlpha = Math.PI / 3.2;

    const alignPosOffset = useMemo(() => {
        if(params.p_r_s === 1 ) return 0.36 + (params.p_r_p - 3) * (-0.08) / 3;
        else if(params.p_r_s === 2 || params.p_r_s === 3) return 0;
        else return 0;
    }, [params.p_r_s, params.p_r_p])
    
    const leftDoorDataArr = useMemo(() => {
        return const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'c_b_l_w' || item.userData.wallName === 'c_b_l_s_w' || item.userData.wallName === 'L_L_R_S_W'));
    }, [const_var.newDoorsArray])

    const rightDoorDataArr = useMemo(() => {
        return const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'c_b_r_w' || item.userData.wallName === 'c_b_r_s_w' || item.userData.wallName === 'R_L_L_S_W'));
    }, [const_var.newDoorsArray]) 

    const roofStylePosOffset = params.p_r_s === 1 ? 0.2 : 0;
    const roofAlpha = Math.atan(params.p_r_p / 12);
    const pos_x = useMemo(() => (-params.p_w / 2 + connectRailWidth / 4 + roofStylePosOffset), [params.p_w, roofStylePosOffset]) 
    const pos_y = useMemo(() => (params.p_h - connectRailHeight / 2 + roofStylePosOffset * 2), [params.p_h, roofStylePosOffset])

    const roofTrussData = useMemo(() => {
        const rungTrussHeight = (( params.p_w / 2 ) * params.p_r_p / 12) / 2 - connectRailHeight / 2;
        const rung_x = -params.p_w / 4;
        const rung_y = params.p_h + rungTrussHeight;
        const braceTrussHight = (params.p_w / 32 * 3 + params.p_w / 64) * (params.p_r_p / 12);
        const braceTrussLength = Math.sqrt(Math.pow(braceTrussHight, 2) + Math.pow((params.p_w / 64 * 3), 2));
        const braceTrussAngle = Math.acos((params.p_w * 3) / (64 * braceTrussLength))
        const brace_x = params.p_w / 32 * 3 - connectRailHeight / 2;
        const brace_y = params.p_h + rungTrussHeight;
        
        return {
            rung: {
                pos_x: rung_x,
                pos_y: rung_y,
            },
            brace: {
                alpha: braceTrussAngle,
                length: braceTrussLength,
                pos_x: brace_x,
                pos_y: brace_y,
            }
        }
    }, [params.p_w, params.p_h, params.p_r_p])

    const roofRailData = useMemo(() => {
        const roofRailLength =  Math.sqrt(Math.pow((params.p_w / 2 - roofStylePosOffset), 2) + Math.pow((params.p_w / 2 - roofStylePosOffset) * params.p_r_p / 12, 2));

        return {
            alpha: roofAlpha,
            length: roofRailLength,
            pos_x: pos_x,
            pos_y: pos_y
        }
    }, [roofAlpha, pos_x, pos_y, params.p_r_p, roofStylePosOffset, params.p_w]) 

    const sideEdgeSlopeRailPosY = useMemo(() => {
        return params.p_h - (sideEdgeSlopeRailLength * Math.sin(sideEdgeSlopeRailAlpha) - (sideEdgeSlopeRailLength * Math.cos(sideEdgeSlopeRailAlpha)) * Math.tan(roofAlpha)) + roofStylePosOffset * 2 - (params.p_r_s === 1 ? params.p_r_p / 60 : 0);
    }, [params.p_h, roofAlpha, roofStylePosOffset, params.p_r_s, params.p_r_p]) 

    const centerVRailLength = useMemo(() => {
        return (((( params.p_w / 2 ) * params.p_r_p / 12) / 2 + 2 * connectRailHeight) / 3) / (Math.PI / 4);
    }, [params.p_r_p, params.p_w])
    

    useEffect(() => {
        if (ref_upperTrussNormal.current && ref_sideSlopeRail.current && ref_loftPieceRail.current && ref_rungHRail.current && ref_centerVRail.current) {
            let index_all = 0;
            new Array(2).fill('').forEach((_, index_dir) => {
                let offsetForDir = 1;
                if (index_dir === 0) offsetForDir = 1;
                else offsetForDir = -1
                
                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                    //----- upper truss -----
                    obj_upperTrussNormal.position.set(offsetForDir * roofRailData.pos_x, roofRailData.pos_y, trussModelPosInfoArr[index_truss]);
                    obj_upperTrussNormal.rotation.y = offsetForDir * Math.PI / 2;
                    obj_upperTrussNormal.rotateOnAxis(new THREE.Vector3(1, 0, 0), offsetForDir * -roofRailData.alpha);
                    
                    if (!!overlapTrussArr && overlapTrussArr.buildingType === 'center' && overlapTrussArr.idArr.includes(index_truss)) {
                        obj_upperTrussNormal.scale.setScalar(0);
                    } else {
                        obj_upperTrussNormal.scale.setScalar(1);
                    }

                    obj_upperTrussNormal.updateMatrix();
                    ref_upperTrussNormal.current.setMatrixAt(index_all, obj_upperTrussNormal.matrix);
                    //---------------------

                    //----- slope rail-----
                    if (offsetForDir === 1) obj_sideSlopeRail.position.set(offsetForDir * (params.p_w / 2 - 0.1 - 0.05), sideEdgeSlopeRailPosY, offsetForDir * trussModelPosInfoArr[index_truss]);
                    else obj_sideSlopeRail.position.set(offsetForDir * (params.p_w / 2 - 0.1 - 0.05), sideEdgeSlopeRailPosY, offsetForDir * -trussModelPosInfoArr[index_truss]);
                    
                    obj_sideSlopeRail.rotation.y = offsetForDir * -Math.PI / 2;
                    obj_sideSlopeRail.rotateOnAxis(new THREE.Vector3(1, 0, 0), offsetForDir * -sideEdgeSlopeRailAlpha);

                    let overlap_left, overlap_right = false;
                    leftDoorDataArr.forEach((item) => {                            
                        if (item.userData.wallName === 'c_b_l_w' || item.userData.wallName === 'c_b_l_s_w') {
                            if (item.positionX - item.width / 2 < trussModelPosInfoArr[index_truss] + connectRailWidth / 2 &&
                                item.positionX + item.width / 2 >= trussModelPosInfoArr[index_truss] - connectRailWidth / 2 &&
                                item.positionY + item.height / 2 >= sideEdgeSlopeRailPosY
                            ) {
                                overlap_left = true;
                            }
                        } else if (item.userData.wallName === 'L_L_R_S_W') {
                            if (-item.positionX - item.width / 2 < trussModelPosInfoArr[index_truss] + connectRailWidth / 2 &&
                                -item.positionX + item.width / 2 >= trussModelPosInfoArr[index_truss] - connectRailWidth / 2 &&
                                item.positionY + item.height / 2 >= sideEdgeSlopeRailPosY
                            ) {
                                overlap_left = true;
                            }
                        }
                    })

                    rightDoorDataArr.forEach((item) => {                            
                        if (item.userData.wallName === 'c_b_r_w' || item.userData.wallName === 'c_b_r_s_w') {
                            if (-item.positionX - item.width / 2 < trussModelPosInfoArr[index_truss] + connectRailWidth / 2 &&
                                -item.positionX + item.width / 2 >= trussModelPosInfoArr[index_truss] - connectRailWidth / 2 &&
                                item.positionY + item.height / 2 >= sideEdgeSlopeRailPosY
                                ) {
                                    overlap_right = true;
                            }
                        } else if (item.userData.wallName === 'R_L_L_S_W') {
                            if (item.positionX - item.width / 2 < trussModelPosInfoArr[index_truss] + connectRailWidth / 2 &&
                                item.positionX + item.width / 2 >= trussModelPosInfoArr[index_truss] - connectRailWidth / 2 &&
                                item.positionY + item.height / 2 >= sideEdgeSlopeRailPosY
                                ) {
                                    overlap_right = true;
                            }
                        } 
                    })
                    
                    if (((offsetForDir === 1 && (overlap_right === true || (const_var.activeTab === 'doorwindow' && params.activeWall === 'c_b_l_s_r_w'))) || 
                        (offsetForDir === -1 && (overlap_left === true || (const_var.activeTab === 'doorwindow' && params.activeWall === 'c_b_r_s_l_w')))) ||
                        hiddenBaseRailIdArr.includes(index_truss))
                    {
                        obj_sideSlopeRail.scale.setScalar(0);
                    } else {
                        obj_sideSlopeRail.scale.setScalar(1);
                    }
                    
                    obj_sideSlopeRail.updateMatrix();
                    ref_sideSlopeRail.current.setMatrixAt(index_all, obj_sideSlopeRail.matrix);
                    //---------------------
                        
                    //----- rung truss-----
                    obj_rungHRail.position.set(roofTrussData.rung.pos_x, roofTrussData.rung.pos_y - 0.025 + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_rungHRail.rotation.y = Math.PI / 2;

                    if (hiddenBaseRailIdArr.includes(index_truss)) obj_rungHRail.scale.setScalar(0);
                    else obj_rungHRail.scale.setScalar(1);

                    obj_rungHRail.updateMatrix();
                    ref_rungHRail.current.setMatrixAt(index_all, obj_rungHRail.matrix);
                    //---------------------

                    //----- roof center rail-----
                    obj_centerVRail.position.set(offsetForDir * params.p_w / 8, roofTrussData.rung.pos_y - 0.025 + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_centerVRail.rotation.x = -Math.PI / 2;
                    obj_centerVRail.rotation.y = offsetForDir * Math.PI / 4;

                    obj_centerVRail.updateMatrix();
                    ref_centerVRail.current.setMatrixAt(index_all, obj_centerVRail.matrix);

                    //---------------------
                    
                    //----- loft piece rail-----
                    obj_loftPieceRail.position.set(offsetForDir * (params.p_w / 2 - connectRailHeight / 2 - 0.005 - 0.05), params.p_h - (0.04 + (params.p_r_p - 1) / 100) + 0.02, offsetForDir * (trussModelPosInfoArr[index_truss] - connectRailWidth / 2));
                    if (offsetForDir === 1) obj_loftPieceRail.rotation.y = 0;
                    else obj_loftPieceRail.rotation.y = Math.PI;

                    if (params.singleSlope) obj_loftPieceRail.scale.setScalar(0);
                    else obj_loftPieceRail.scale.setScalar(1);
                    
                    obj_loftPieceRail.updateMatrix();
                    ref_loftPieceRail.current.setMatrixAt(index_all, obj_loftPieceRail.matrix);
                    //---------------------

                    index_all ++;
                })
            })
            
            
            ref_upperTrussNormal.current.instanceMatrix.needsUpdate = true;
            ref_sideSlopeRail.current.instanceMatrix.needsUpdate = true;
            ref_rungHRail.current.instanceMatrix.needsUpdate = true;
            ref_loftPieceRail.current.instanceMatrix.needsUpdate = true;
            ref_centerVRail.current.instanceMatrix.needsUpdate = true;
        }
    }, [ref_upperTrussNormal.current, ref_sideSlopeRail.current, ref_loftPieceRail.current, ref_rungHRail.current, ref_centerVRail.current, trussModelPosInfoArr, overlapTrussArr, roofRailData, sideEdgeSlopeRailPosY, leftDoorDataArr, params.singleSlope, params.freeStandingSide, const_var.activeTab, params.activeWall, hiddenBaseRailIdArr, params.p_h, params.p_r_p, params.p_w])

    const ref_upperTrussHighlight = useMemo(() => {
        if (overlapTrussArr.idArr?.length > 0) {
            let index_all = 0;
            const instanceMat = [];
            new Array(2).fill('').forEach((_, index_dir) => {
                let offsetForDir = 1;
                if (index_dir === 0) offsetForDir = 1;
                else offsetForDir = -1;
                
                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                    obj_upperTrussHighlight.position.set(offsetForDir * roofRailData.pos_x, roofRailData.pos_y, trussModelPosInfoArr[index_truss]);
                    obj_upperTrussHighlight.rotation.y = offsetForDir * Math.PI / 2;
                    obj_upperTrussHighlight.rotateOnAxis(new THREE.Vector3(1, 0, 0), offsetForDir * -roofRailData.alpha);

                    if (!!overlapTrussArr && overlapTrussArr.buildingType === 'center' && overlapTrussArr.idArr.includes(index_truss)) {
                        obj_upperTrussHighlight.scale.setScalar(1);
                    } else {
                        obj_upperTrussHighlight.scale.setScalar(0);
                    }

                    obj_upperTrussHighlight.updateMatrix();
                    instanceMat.push(...obj_upperTrussHighlight.matrix.elements);
                })
            })
            
            return new THREE.InstancedBufferAttribute(new Float32Array(instanceMat), 16);
        }
    }, [overlapTrussArr.idArr, trussModelPosInfoArr, overlapTrussArr, roofRailData, params.p_h, params.p_w, params.p_r_p])

    return (
        <group position={[0, -offset, 0]} name='TWCT-truss-legs'>
        <>
            {/* --- upper truss model --- */}
            <instancedMesh ref={ref_upperTrussNormal} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(roofRailData.length - (0.05 - (parseFloat(params.p_r_p) - 3) * 0.017 / 3))]} />
                <meshPhongMaterial color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
            </instancedMesh>
            {/* ------------------------- */}

            {/* --- slope rail model --- */}
            <instancedMesh ref={ref_sideSlopeRail} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(sideEdgeSlopeRailLength - 0.15)]} />
                <meshPhongMaterial color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
            </instancedMesh>
            {/* ------------------------- */}

            {/* --- roof center rail model --- */}
                <instancedMesh ref={ref_centerVRail} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(connectRailHeight, connectRailWidth), extrudeSettings(centerVRailLength)]} />
                    <meshPhongMaterial color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
                </instancedMesh>
            {/* ------------------------- */}

            {/* --- loft piece rail model --- */}
            <instancedMesh ref={ref_loftPieceRail} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                <extrudeGeometry args={[railLoftModel(roofStylePosOffset, roofStylePosOffset * 2, connectRailHeight, params.p_r_p), extrudeSettings(connectRailWidth)]} />
                <meshPhongMaterial color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
            </instancedMesh>
            {/* ------------------------- */}

            {/* --- rung truss model --- */}
            <instancedMesh ref={ref_rungHRail} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(params.p_w / 2)]} />
                <meshPhongMaterial color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
            </instancedMesh>
            {/* ------------------------- */}
            
            {/* --- upper truss highlight model --- */}
            {
                overlapTrussArr.idArr?.length > 0 && <instancedMesh instanceMatrix-needsUpdate={true} instanceMatrix={ref_upperTrussHighlight} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false} >
                    <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(roofRailData.length - (0.05 - (parseFloat(params.p_r_p) - 3) * 0.017 / 3))]} />
                    <meshBasicMaterial depthTest={false} color={'#900000'} opacity={0.7} transparent />
                </instancedMesh>
            }
            {/* ------------------------- */}

        </>
    </group>
    )
}